module.exports = __webpack_public_path__ + "img/plunge.28931265.jpg";